module.exports = __webpack_public_path__ + "static/img/one.8e7d417.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/one.png
// module id = xX5m
// module chunks = 1